import Main from './components/Main.vue'
import Approve from './components/Approve.vue'
import Pdf from './components/Pdf.vue'

export default [
    {
        name: 'my-quotation.show',
        path: '/my-quotation/:code',
        component: Main,
        meta: {
            requiresAuth: null
        }
    },
    {
        name: 'my-quotation.pdf',
        path: '/my-quotation/:code/pdf',
        component: Pdf,
        meta: {
            requiresAuth: null
        }
    },
    {
        name: 'my-quotation.approve',
        path: '/my-quotation/:code/approve',
        components: {
            modal: Approve
        },
        meta: {
            requiresAuth: null
        }
    }
]



// WEBPACK FOOTER //
// ./src/modules/my-quotation/routes.js